<template>
  <h6 class="fg-header" @click="$emit('open', filter.filterId)">
    {{ filter.title }}
  </h6>
  <div class="fg-body form-group d-flex flex-wrap" id="filterColor">
    <div
      class="form-check"
      v-for="option in filter.options"
      :key="option.value"
      :style="{ marginRight: '5px' }"
    >
      <input
        class="form-check-input"
        :style="{ 'background-color': option.label }"
        type="checkbox"
        :id="
          option.value === 'Del Día'
            ? option.value.toLowerCase().replace(/\s+/g, '')
            : option.value.toLowerCase()
        "
        :value="option.value"
        :checked="option.selected"
        @change="option.selected = !option.selected"
      />
    </div>
  </div>
  <!-- .fg-body -->
</template>
<script src="./ctrl-color-filter.js"></script>
